/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { UserEntity } from './user-entity';
export class CandidateWhiteboardEntity extends Entity {
  body: string | null = null;
  candidateId: string | null = null;
  createdAt: string | null = null;
  id: string = '';
  lastUpdatedBy: string | null = null;
  updatedAt: string | null = null;
  updatedByUser: UserEntity | null = null;
  static override key = 'CandidateWhiteboard';
  static override get schema() {
    return {
      updatedByUser: UserEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidateWhiteboard' in input
    ) {
      const { CandidateWhiteboard: wrapped, ...rest } = input as {
        CandidateWhiteboard: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}